import Vue from "vue";
import axios from "axios";
import i18n from "@/i18n";

export default {
  baseURL: process.env.BASE_URL + "api/dashboard",

  getDashboard(filter, cancelToken, localizationId) {
    return axios
      .get("dashboarddata", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "client-id": filter ? filter.client || null : null,
          "project-ids": filter ? filter.projects || null : null,
          "survey-ids": filter ? filter.surveys || null : null,
          "wave-ids": filter ? filter.waves || null : null,
          "scenario-ids": filter ? filter.scenarios || null : null,
          "custompropertyvalue-ids": filter
            ? filter.customProperties || null
            : null,
          "clientlocation-ids": filter ? filter.locations || null : null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getDashboardKpiQuestions(filter, options, cancelToken) {
    return axios.post("dashboard-kpi-questions", 
      {
        "survey-ids": filter ? filter.surveys || null : null,
        "wave-ids": filter ? filter.waves || null : null,
        "scenario-ids": filter ? filter.scenarios || null : null,
        "custompropertyvalue-ids": filter ? filter.customProperties || null : null,
        "clientlocation-ids": filter ? filter.locations || null : null,
        "kpi-codes": filter ? filter.kpiCodes || null : null,
        'include-answers': options?.includeAnswers,
        'localization-id': options?.localizationId ?? i18n.locale
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function(response) {
        return response;
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getDashboardWidgetData(filter, cancelToken, localizationId) {
    return axios
      .get("dashboardwidgetdata", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "client-id": filter ? (filter.client || null) : null,
          "project-ids": filter ? (filter.projects || null) : null,
          "survey-ids" : filter ? (filter.surveys || null) : null,
          "wave-ids" : filter ? (filter.waves || null) : null,
          "scenario-ids" : filter ? (filter.scenarios || null) : null,
          "custompropertyvalue-ids": filter ? (filter.customProperties || null) : null,
          "clientlocation-ids": filter ? (filter.locations || null) : null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getDashboardRankingData(filter, options, cancelToken) {
    return axios
      .get("rankingdata", {
        baseURL: this.baseURL,
        params: {
          "survey-ids" : filter ? (filter.surveys || null) : null,
          'aggregation-level1': options ? options.aggregationLevel1 : null,
          'aggregation-level2': options ? options.aggregationLevel2 : null,
          'top-result-count': options ? options.topResultCount : null,
          'wave-ids': filter ? (filter.waves || null) : null,
          "scenario-ids" : filter ? (filter.scenarios || null) : null,
          'clientlocation-ids': filter ? (filter.locations || null) : null,
          'property-ids': filter ? (filter.customProperties || null) : null,
          'kpi-ids': filter ? (filter.kpiIds || null) : null,
          'include-kpis':  options ? options.includeKpis : null,
          'include-clusters': options ? options.includeClusters : null,
          'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
  },

  getDashboardFunnelData(filter, cancelToken) {
    return axios
      .get("funneldata", {
        baseURL: this.baseURL,
        params: {
          "localization-id": i18n.locale,
          "client-id": filter ? filter.client || null : null,
          "project-ids": filter ? filter.projects || null : null,
          "survey-id": filter ? filter.surveys || null : null,
          "wave-ids": filter ? filter.waves || null : null,
          "scenario-ids": filter ? filter.scenarios || null : null,
          "custompropertyvalue-ids": filter
            ? filter.customProperties || null
            : null,
          "clientlocation-ids": filter ? filter.locations || null : null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
  },

  getDashboardFunnelResults(filter, cancelToken, answerIds) {
    return axios
      .get("funnelresults", {
        baseURL: this.baseURL,
        params: {
          "localization-id": i18n.locale,
          "client-id": filter ? filter.client || null : null,
          "project-ids": filter ? filter.projects || null : null,
          "survey-id": filter ? filter.surveys || null : null,
          "wave-ids": filter ? filter.waves || null : null,
          "scenario-ids": filter ? filter.scenarios || null : null,
          "custompropertyvalue-ids": filter
            ? filter.customProperties || null
            : null,
          "clientlocation-ids": filter ? filter.locations || null : null,
          "answer-ids": answerIds ? answerIds : null
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
  },

  getApplicationManual(localizationId, documentVariant, cancelToken) {
    return axios
      .get("manual", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          documentvariant: documentVariant
        },
        responseType: "blob",
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getOptions(filter, cancelToken, localizationId) {
    return axios
      .get("dashboardfilters", {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId || i18n.locale,
          "client-id": filter ? (filter.client || null) : null,
          "survey-ids" : filter ? (filter.surveys || null) : null,
          "wave-ids" : filter ? (filter.waves || null) : null,
          "scenario-ids" : filter ? (filter.scenarios || null) : null,
          "custompropertyvalue-ids": filter ? (filter.customProperties || null) : null,
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getGuideContent(localizationId) {
    return axios.get(
      'guide-content',
      {
        baseURL: this.baseURL,
        params: {
          "localization-id": localizationId
        },
      }
    )
  },

  updateGuideContent(guideContent) {
    return axios.post(
      'update-guide-content', 
      guideContent,
      {
        baseURL: this.baseURL
      }
    )
  },

  setGuideContent(guideContent) {
    return axios.post(
      'set-guide-content', 
      guideContent,
      {
        baseURL: this.baseURL
      }
    )
  },

  getTableColumns(options, cancelToken) {
    return axios.get( "/cx-table-structure",
      {
        baseURL: this.baseURL,
        params: {
          "CountryId": options.countryId,
          "ClientId": options.clientId,
          "TableId": options.tableId, // "market", "retailer"
          "LocalizationId": options.localizationId || i18n.locale
        },
        cancelToken: cancelToken?.token || null
      }
    ).catch(function(error){
      console.log(error);
      return Promise.reject(error);
    });
  },
  
  /**************************/
  /* CX - CustomerXperience */
  /**************************/

  getCXMarket(filter, options, cancelToken) {
    return axios.post(
      "/cxmarket",
      {
        LocalizationId: filter.LocalizationId || i18n.locale,
        ClientId: filter.ClientId || null,

        SearchText:     options?.searchText || null,
        PageSize:       options?.pageSize || null,
        Page:           options?.page || null
      },
      {
        baseURL:        this.baseURL,
        cancelToken:    cancelToken?.token || null
      }
    );
  },

  getCXDealers(filter, options, cancelToken) {
    return axios.post(
      "/cxdealers",
      {
        CountryId:      filter.CountryId || null,
        ClientId:       filter.ClientId || null,
        LocalizationId: filter.LocalizationId || i18n.locale,

        // Optional
        SearchText:     options?.searchText || null,
        PageSize:       options?.pageSize || 999,
        Page:           options?.page || null
      },
      {
        baseURL:        this.baseURL,
        cancelToken:    cancelToken?.token || null
      }
    )
  },

  getDealer(clientLocationId, cancelToken, scoreId) {
    if (clientLocationId == null || clientLocationId == "") return Promise.reject();

    return axios.post(
      "/dealer",
      {
        ClientLocationId: clientLocationId || null,
        LocalizationId: i18n.locale,
        ScoreId: scoreId
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    );
  },

  getDealerRebuild(clientLocationId, cancelToken, scoreId) {
    if (clientLocationId == null || clientLocationId == "") return Promise.reject();

    return axios.post(
      "/dealer-cxrebuild",
      {
        ClientLocationId: clientLocationId || null,
        LocalizationId: i18n.locale,
        ScoreId: scoreId,
        NumberOfMonths: 12
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    );
  },

  getDealerFocuskpis(clientLocationId, cancelToken, scoreId) {
    if (
      clientLocationId == null || 
      clientLocationId == "" || 
      scoreId == null
    ) {
      return Promise.reject();
    }

    return axios.post(
      "/dealer-focuskpis",
      {
        ClientLocationId: clientLocationId || null,
        LocalizationId: i18n.locale,
        ScoreId: scoreId,
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    )
  },

  GetDealerExploration(clientLocationId, cancelToken, scoreId) {
    if (clientLocationId == null || clientLocationId == "") return Promise.reject();

    return axios.post(
      "/dealer-exploration",
      {
        ClientLocationId: clientLocationId || null,
        LocalizationId: i18n.locale,
        ScoreId: scoreId,
        NumberOfMonths: 12
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    );
  },

  GetDealerApisFromSurveys(clientLocationId, cancelToken, scoreId, getNonExploration) {
    if (clientLocationId == null || clientLocationId == "") return Promise.reject();

    return axios.post(
      "/dealer-apis-from-surveys",
      {
        ClientLocationId: clientLocationId || null,
        LocalizationId: i18n.locale,
        ScoreId: scoreId,
        GetNonExploration: getNonExploration
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    );
  },

  GetDealerKpis(clientLocationId, cancelToken, scoreId, kpiGroupCode) {
    if (clientLocationId == null || clientLocationId == "") return Promise.reject();

    return axios.post(
      "/dealer-kpis",
      {
        ClientLocationId: clientLocationId || null,
        LocalizationId: i18n.locale,
        ScoreId: scoreId,
        KpiGroupCode: kpiGroupCode
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    );
  },

  getHistorical(filter, cancelToken, dateFrom, dateTo, apiId) {
    return axios.post(
      "/historical",
      {
        ClientId: filter?.client || null,
        ClientLocationId: filter?.locations || null,
        CountryId: filter?.countries || null,
        Date_From: dateFrom || null,
        Date_To: dateTo || null,
        ApiId: apiId || null,
        RatingTypes: null // null = OverallScore
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    );
  },

  getCompetitor(
    competitorId,
    { google = false, seobility = false, autoscout = false, mobile = false }
  ) {
    if (!competitorId) return Promise.reject();

    return axios.post(
      "/competitor",
      {
        CompetitorId: competitorId,
        Google: google || false,
        Seobility: seobility || false,
        Autoscout: autoscout || false,
        Mobile: mobile || false,
        GermanSeo: (i18n?.locale?.startsWith("de") || false) && i18n?.locale !== "deflt",
      },
      {
        baseURL: this.baseURL
        //cancelToken:  cancelToken?.token || null
      }
    );
  },

  getDashboardAggregatedData(filter, options, cancelToken) {
    return axios.post(
      "aggregateddata",
      {
        SurveyIds: filter?.surveyIds?.join() || null,
        AggregationLevel1: options?.aggregationLevel1 || null,
        AggregationLevel2: options?.aggregationLevel2 || null,
        PivotAggregationLevel2: options?.pivotAggregationLevel2 || null,
        IsRanking: options?.isRanking || null,
        TopResultCount: options?.topResultCount || null,
        WaveIds: filter?.waveIds?.join() || null,
        ScenarioIds: filter?.scenarioIds?.join() || null,
        ClientlocationIds: filter?.locations?.join() || null,
        CountryIds: filter?.countryIds?.join() || null,
        SurveyInstanceStatusMinimum:
          filter?.surveyInstanceStatusMinimum || null,
        SurveyInstanceStatusMaximum:
          filter?.surveyInstanceStatusMaximum || null,
        PropertyIds: filter?.propertyIds?.join("|") || null,
        PropertyUseLogicalAnd: options?.propertyUseLogicalAnd || null,
        KpiIds: filter?.kpiIds?.join() || null,
        SearchText: filter?.searchText || null,
        IncludeKpiPoints: options?.includeKpiPoints || null,
        IncludeKpiPercentages: options?.includeKpiPercentages || null,
        IncludeClusterPoints: options?.includeClusterPoints || null,
        IncludeClusterPercentages: options?.includeClusterPercentages || null,
        IncludeTestchecks: filter?.includeTestchecks || null,
        PageSize: options?.pageSize || null,
        Page: options?.page || null,
        LocalizationId: options?.localizationId || i18n.locale
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken?.token || null
      }
    );
  },

  getClientLocationCountries(clientId, cancelToken) {
    return axios
      .get("client-location-countries", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId,
          // REP.CountryText has only de-DE and deflt ?
          "localization-id": i18n?.locale?.startsWith("de")
            ? i18n?.locale
            : "deflt"
        },
        cancelToken: cancelToken ? cancelToken.token : null
      })
  },

  getSeoReport(id, apiId, isCompetitor, cancelToken) {
    return axios.get(`get-seo-report/${id}`,
      { 
        baseURL: this.baseURL,
        params: {
          "api-id": apiId,
          "is-competitor": isCompetitor
        },
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
        
        return Promise.reject(error);
      });
  },

  getSurveyData(options, cancelToken) {
    return axios.get('survey',
      {
        baseURL: this.baseURL,
        params: {
          "external-survey-id": options.externalSurveyId,
          "client-location-id": options.clientLocationId,
          "localization-id":    options.localizationId || i18n.locale,
        },
        cancelToken: cancelToken?.token || null
      });
  },

  setFirstAidKitAsResolved(options, cancelToken) {
    return axios.get('resolve',
      {
        baseURL: this.baseURL,
        params: {
          "first-aid-kit-group-id": options.firstAidKitGroupId,
          "client-location-id":     options.clientLocationId
        },
        cancelToken: cancelToken?.token || null
      });
  },

  getSurveyJson(externalSurveyId, localizationId, cancelToken) {
    return axios.get('survey-json',
      {
        baseURL: this.baseURL,
        params: {
          "external-survey-id": externalSurveyId,
          "localization-id": localizationId
        },
        cancelToken: cancelToken?.token || null
      });
  },

  getScores(clientId, countryId) {
    return axios
      .get("get-scores", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId,
          "country-id": countryId
        }
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getThresholds(clientId, scoreId) {
    return axios
      .get("get-thresholds", {
        baseURL: this.baseURL,
        params: {
          "client-id": clientId,
          "score-id": scoreId
        }
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getCxReport(params, cancelToken) {
    return axios
      .get("get-cxreport", {
        baseURL: this.baseURL,
        params: params,
        responseType: 'blob',
        cancelToken: cancelToken?.token || null
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
      
  },

  async GetSurveyKpisByYear(kpiIds, localizationId, clientLocationId, year) {
    return axios
      .get("get-surveykpis-by-year", {
        baseURL: this.baseURL,
        params: {
          "kpi-ids": kpiIds,
          "localization-id": localizationId,
          "client-location-id": clientLocationId,
          "year": year 
        }
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  async GetSurveyWavesOfSameSurvey(waveIds) {
    return axios
      .get("get-surveywaves-of-same-survey", {
        baseURL: this.baseURL,
        params: {
          "wave-ids": waveIds
        }
      })
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  GetSurveyKpiQuestionAndAnswerTexts(body) {
    return axios
      .post(
        "get-surveykpi-question-and-answer-texts", 
        body,
        {
          baseURL: this.baseURL,
        }
      )
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  getHealingStatus(clientLocation, brand) {
    return axios.get("get-healing-status", {
    baseURL: this.baseURL,
    params: {
      "client-location-id": clientLocation,
      "brand": brand
    }}).catch(function(error){
      console.log(error);
      return Promise.reject(error);
    });
  },

  CreateMarginHealing(body) {
    return axios
      .post(
        "margin-healing", 
        body,
        {
          baseURL: this.baseURL,
        }
      )
      .catch(function(error) {
        console.log(error);
        return Promise.reject(error);
      });
  },

  async GetMarginManagementData(clientLocation, brand) {
    return axios.get("marginmanagement", {
      baseURL: this.baseURL,
      params: {
        "client-location-id": clientLocation,
        "brand": brand
      }
    }).catch(function(error){
      console.log(error);
      return Promise.reject(error);
    })
  },

  async GetInControlData(clientLocation, brand) {
    return axios.get("incontrol", {
      baseURL: this.baseURL,
      params: {
        "client-location-id": clientLocation,
        "brand": brand
      }
    }).catch(function(error){
      console.log(error);
      return Promise.reject(error);
    })
  },

  GetSophusRawData(clientLocation, waveName, brand) {
    return axios.get("get-sophus-rawdata", {
      baseURL: this.baseURL,
      params: {
        "client-location-id": clientLocation,
        "wave-name": waveName,
        "brand": brand
      }
    })
    .catch(function(error){
      console.log(error);
      return Promise.reject(error);
    })
  },

  GetSurveyInstanceDataSet(surveyInstanceIds, localizationId) {
    return axios.get("get-survey-instance-data-set", {
      baseURL: this.baseURL,
      params: {
        "survey-instance-ids": surveyInstanceIds,
        "localization-id": localizationId
      }
    })
    .catch(function(error){
      console.log(error);
      return Promise.reject(error);
    })
  },

  getSurveyUploadFile(surveyInstanceId, surveyQuestionId, fileName) {
    return axios.get("upload-file", {
      baseURL: this.baseURL,
      responseType: 'blob',
      params: {
        'survey-instance-id': surveyInstanceId,
        'survey-question-id': surveyQuestionId,
        'file-name': fileName,
      }
    })
    .catch(function(error){
      console.log(error);
      return Promise.reject(error);
    })
  },
  
  GetLoyaltyBonusData(clientLocation, year) {
    return axios.get("loyalty-bonus", {
      baseURL: this.baseURL,
      params: {
        "client-location-id": clientLocation,
        "year": year
      }
    })
    .catch(function(error){
      console.log(error);
      return Promise.reject(error);
    })
  },
  GetLoyaltyBonusPercentages(year) {
    return axios.get("loyalty-bonus-percentages", {
      baseURL: this.baseURL,
      params: {
        "year": year
      }
    })
    .catch(function(error){
      console.log(error);
      return Promise.reject(error);
    })
  },
  GetLoyaltyBonusYears(clientLocationId) {
    return axios.get("loyalty-bonus-years", {
      baseURL: this.baseURL,
      params: {
        "locationId": clientLocationId
      }
    })
    .catch(function(error){
      console.log(error);
      return Promise.reject(error);
    })
  },
};
